import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformEnterprise } from './enterprises.transformers';
import { EnterprisesCollection } from './enterprises.types';

export function enterprisesReducer(
  state: CollectionStateSlice<EnterprisesCollection> = {},
  action: CollectionActions<EnterprisesCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'enterprises') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<EnterprisesCollection>(
          state,
          transformIntoDocuments(result.enterprises, transformEnterprise),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
